import api from '~services/axios';

export default {
  // 拜访记录
  apiGetVisitList: params => api.post('/api/visit/querylist', params),

  // 拜访记录详情
  apiGetVisitDetail: params => api.get('/api/visit/detail', { params }),

  // 拜访记录-拜访类型
  apiGetVisitType: params => api.get('/api/common/query/category', { params }),

  // 拜访记录-导出
  apiHandleVisitExport: (params, config) =>
    api.post('/api/visit/export', params, config),

  // 拜访删除
  apiHandleDeleteVisit: params => api.post('/api/visit/delete', params),

  // 拜访新增
  apiHandleAddVisit: params => api.post('/api/visit/add', params),

  // 拜访编辑
  apiHandleUpdateVisit: params => api.post('/api/visit/update', params),

  // 获取拜访团队
  apiGetVisitTeams: params => api.get('/api/visit/queryvisitteam', { params }),

  // 文件上传
  apiVisitUploadFile: (params, config) =>
    api.post('/api/visit/uploadfile', params, config),

  // 文件上传删除
  apiDeleteVisitUploadFile: params => api.post('/api/visit/deletefile', params),

  // 拜访- 客户
  apiGetVisitCustomerDataList: params =>
    api.get('/api/visit/queryCustomer', { params }),
  // 拜访- 医生客户
  apiGetVisitMedicalCustomerDataList: params =>
    api.get('/api/visit/queryDoctorCustomer', { params }),
  // 拜访- 客户 - 业务员
  apiGetVisitCustomerSalesmanDataList: params =>
    api.get('/api/visit/queryteamuser', { params }),

  // 拜访- 客户 - 联系人
  apiGetVisitCustomerConvertDataList: params =>
    api.get('/api/visit/queryCustomerConvert', { params }),

  // 拜访- 商机
  apiGetVisitBusinessDataList: params =>
    api.get('/api/visit/queryBusiness', { params }),

  // 拜访- 商机 - 联系人
  apiGetVisitBusinessConvertDataList: params =>
    api.get('/api/visit/queryBusinessConvert', { params }),

  // 拜访- 线索
  apiGetVisitCluesDataList: params =>
    api.get('/api/visit/queryClues', { params }),
};
